import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { IRejectApprovals } from '../../Interfaces/IRejectApprovals';
import { MyApprovalsService } from '../../services/myApprovals-service';

@Component({
  selector: 'app-reject-approval',
  templateUrl: './reject-approval.component.html',
  styles: [
  ]
})
export class RejectApprovalComponent implements OnInit {

  display: boolean = false;
  formGroup: FormGroup;
  loading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<RejectApprovalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IRejectApprovals[],
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService,
    private myApprovalsService: MyApprovalsService
  ) {

    this.display = true;
    this.formGroup = this.formBuilder.group({
      txtrejectcomment: [
        "",
        [
          Validators.required,
          Validators.pattern('.*[a-zA-Z].*')
        ]
      ],
    });
  }

  ngOnInit(): void {
  }

  Alert(title: string, message: string) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: title,
			message: this.translate.TranslateKey(message),
			shown: true,
		});
  }

  Close() {
    this.dialogRef.close();
  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }

  Save() {
    this.data.forEach(elementVisitorByVisit => {
      this.myApprovalsService
        .RejectVisitByVisitor(elementVisitorByVisit.fk_visitor_by_visit, elementVisitorByVisit.fk_approver_area, elementVisitorByVisit.fkApprover, this.formGroup.controls.txtrejectcomment.value)
        .subscribe(
          (result: TransactionResult<boolean>) => {
            this.loading = false;
            if (result.success) {
              this.Alert("Success", "MYAPPROVALS.REJECT_VISIT");
              this.display = false;
              this.Close();
            } else {
              this.loading = false;
              this.Alert("Error", "MYAPPROVALS.Failed_to_reject");
            }
          },
          (error: any) => { this.ErrorAlert(error); this.loading = false; }
        );
    });
  }

}
